/* @flow */

import React from 'react';
import FolderItem from './FolderItem';

type Props = {
  folders: List<BucketFolder>,
  resourcesCountByFolder: Map<number, number>,
  onUploadFiles: (folder: BucketFolder, files: FileList) => void,
  onRemove: (folder: BucketFolder) => void,
  isRemoving: boolean,
};

const FolderList = ({
  folders,
  resourcesCountByFolder,
  onUploadFiles,
  onRemove,
  isRemoving,
}: Props) => {
  const resourcesCount = folder => resourcesCountByFolder.get(folder) || 0;

  return (
    <div className="ui three cards">
      {folders.map(f => (
        <FolderItem
          key={f.id}
          folder={f}
          resourcesCount={resourcesCount(f.id)}
          onUpload={onUploadFiles}
          onRemove={onRemove}
          isRemoving={isRemoving}
        />
      ))}
    </div>
  );
};

export default FolderList;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folders/components/FolderList.js